export default "__VITE_ASSET__PBm1yBCs__"